import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierScorecardReport extends Layout {
    checkboxExcludeCarrierName: Checkbox;
    checkboxGroupBy: Checkbox;
    excludabletextboxCarrier: ExcludableTextbox;
    excludabletextboxCategories: ExcludableTextbox;
    excludabletextboxManager: ExcludableTextbox;
    excludabletextboxMetrics: ExcludableTextbox;
    excludabletextboxSalesperson: ExcludableTextbox;
    labelPercent: Label;
    sourceCarrierScorecardReport: DataSource;
    textboxCalculationDate: Textbox;
    textboxCarrierRanking: Textbox;
    textboxGroupBy: Textbox;
    textboxRankingValue: Textbox;
    textboxReportType: Textbox;
    textboxSortBy: Textbox;
    textboxSortGroupsBy: Textbox;
    textboxSortMetricBy: Textbox;
}
